import { axiosInstance } from 'src/util/axios/instance.axios'
import { ComparisonEntity, ComparisonRequest, ComparisonResponse } from '../model/my-team-comparison'

// Fetch dropdown lists
export async function getComparisonTeams(): Promise<ComparisonEntity[]> {
  const { data } = await axiosInstance.request<ComparisonEntity[]>({
    url: '/my-team/comparison/teams',
  })

  return data
}

export async function getComparisonRoles(): Promise<ComparisonEntity[]> {
  const { data } = await axiosInstance.request<ComparisonEntity[]>({
    url: '/my-team/comparison/roles',
  })

  return data
}

export async function getComparisonUsers(): Promise<ComparisonEntity[]> {
  const { data } = await axiosInstance.request<ComparisonEntity[]>({
    url: '/my-team/comparison/users',
  })

  return data
}

// Comparison endpoints
export async function compareTeams(request: ComparisonRequest): Promise<ComparisonResponse> {
  const { data } = await axiosInstance.request<ComparisonResponse>({
    url: '/my-team/comparison/teams',
    method: 'POST',
    data: request,
  })

  return data
}

export async function compareRoles(request: ComparisonRequest): Promise<ComparisonResponse> {
  const { data } = await axiosInstance.request<ComparisonResponse>({
    url: '/my-team/comparison/roles',
    method: 'POST',
    data: request,
  })

  return data
}

export async function compareUsers(request: ComparisonRequest): Promise<ComparisonResponse> {
  const { data } = await axiosInstance.request<ComparisonResponse>({
    url: '/my-team/comparison/users',
    method: 'POST',
    data: request,
  })

  return data
}
